import React, { useContext, useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import Utils from "../../../core/utilities/Utils";

const SupplierDashboardCompaniesRiskBox = ({ t, selYear }) => {

  const lsData = JSON.parse(localStorage.getItem("authority"));
  const supplierId = lsData.profile.user.id;
  const { glbRegulation } = useContext(RegulationContext);
  const [companies, setCompanies ] = useState([]);
	const glbRegulationId = glbRegulation?.id ?? '';
  const annualYear = selYear;

  useEffect(() => {
    if (glbRegulationId) {
			const month = Utils.getMonthFromFrequency(glbRegulation.frequency);      
			getTop5Companies(month);
		}
  }, [glbRegulationId, annualYear]);

  const getTop5Companies = (month) => {
    CompanyDashboardService.getTop5CompaniesWithHighRisk(
      supplierId, 
      glbRegulation?.code, 
      annualYear + '-' + month + '-01'
    ).then(response => {
      if (response.status === 200 ) {
        setCompanies(response.data);
      }
    }).catch(error => {
      console.log("err", error);
    });
  };

  const getColorClass = (score) => {
    if (score >= 0 && score < 3) {
      return 'color-2AA815 bg-badge-low';
    } else if (score >= 3 && score < 6) {
      return 'color-DABE25 bg-badge-Medium';
    } else {
      return 'color-DB0001 bg-badge-High';
    }
  };

  return (
    <div className="SC-Risk_parameterView02 pt-2">
      <div className="SC-RiskpView02_in">
            <div className="SC-RiskpView02_in">
              <ul>
                <li>
                  <p className="m-0"> {t("Companies.label")}</p>
                </li>
                <li>
                  <p className="m-0">{t("Score.label")} (1-10)</p>
                </li>
              </ul>
            </div>
            {
              companies?.map((company, index) => (
                <div className="SC-RiskpView02_in" key={index}>
                  <ul>
                    <li>
                      <div><strong>{company.companyName}</strong></div>
                      <div>{company.countryName}</div>
                    </li>
                    <li>
                      <ProgressBar
                        now={company.riskScore * 10}
                        label={company.riskScore}
                        className={getColorClass(company.riskScore)}
                      />
                    </li>
                  </ul>
                </div>
              ))
            }
          </div>
    </div>
  );
};
export default withTranslation()(SupplierDashboardCompaniesRiskBox);
